<template>
  <b-modal v-model="$store.state.authentication.showConfirmCodeModal" @ok="sendConfirmCode">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.confirmEmailCodePage.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.confirmEmailCodePage.confirmCodeLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="confirmCode"
          :state="isConfirmCodeValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.confirm
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "ConfirmCodeDialog",
  data() {
    return {
      confirmCode: null,
      isConfirmCodeValid: null,
    };
  },
  methods: {
    sendConfirmCode() {
        if (!this.confirmCode) {
            this.isConfirmCodeValid = false;
            event.preventDefault();
            return;
        }

        this.$store.dispatch("authentication/checkEmailCode", {
            code: this.confirmCode
          });
    },
  }
};
</script>

<style scoped>
.modal {
  display: block;
  background: rgba(0, 0, 0, 0.5);
}
</style>
